import injectSheet from 'react-jss'
import classNames from 'classnames'
import ParallaxImg from '@/components/ParallaxImg'
import DelayLink from '@/components/DelayLink'
import { removeBr } from '@/utils/strings'
import style from './style'

const FeaturedPosts = ({
  className,
  classes,
  items,
}) => {
  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
    >
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <div className={classes.postList}>
            {items.map((item) => {
              return (
                <div
                  className={classes.item}
                  key={item.id}
                >
                  <DelayLink
                    to={item.link}
                    className={classes.itemImage}
                  >
                    <ParallaxImg
                      img={item.img}
                      title={removeBr(item.title)}
                    />
                  </DelayLink>
                  <div className={classes.itemInfo}>
                    {item.cat && <p className={classes.itemCategory}>{item.cat}</p>}
                    <h3 className={classes.itemTitle}>
                      <DelayLink to={item.link}>{removeBr(item.title)}</DelayLink>
                    </h3>
                    <div className={classes.itemText}>
                      {item.text}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default injectSheet(style)(FeaturedPosts)
